<template>
  <div class="vue-group">
    <li v-for="(item, idx) in selectableInputs" :key="idx">
      <span>
        <input
          v-model="value"
          :id="`${name}_${item.value}`"
          type="radio"
          :name="name"
          :value="item.value"
          @focus="event => emit('focus', event)"
          @blur="event => emit('blur', event)"
        />
        <label :for="`${name}_${item.value}`" class="inquiry-form-radio">{{
          item.label
        }}</label>
      </span>
    </li>
  </div>
</template>

<script setup>
import { watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useField } from 'vee-validate';

const store = useStore();

const emit = defineEmits(['focus', 'blur']);

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  validator: {
    type: Object,
    required: true
  },
  selectableItems: {
    type: Array,
    required: true
  },
  labelId: {
    type: String,
    default: ''
  },
  labelTemplate: {
    type: String,
    required: false,
    default: '{}'
  },
  dispatcher: {
    type: String,
    required: true
  }
});

const initialValue = computed(
  () =>
    (store.state.formData && store.state.formData[props.name]) ||
    (store.state.positionInquiryMail &&
      store.state.positionInquiryMail.formData[props.name])
);

const { value } = useField(props.name, props.validator, {
  validateOnMount: false,
  initialValue: initialValue.value
});

watch(value, newValue => store.dispatch(props.dispatcher, newValue));

watch(initialValue, () => {
  value.value = initialValue.value;
});

const selectableInputs = computed(() => {
  return props.selectableItems.map(item => ({
    value: item.code,
    label: props.labelTemplate.replace('{}', item.text)
  }));
});
</script>
